import { useRef, useState } from "react";

const CompanySurveyReadOnlyRow = ({ index, t, companySurveyItem, handleSubmit, handleDeleteClick, oddIdx, add, setError }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const shouldBeReviewedRef = useRef(null);
    const [isShouldBeReviewed, setIsShouldBeReviewed] = useState(companySurveyItem.shouldBeReviewed);
    const shareManuallyRef = useRef(null);
    const [isShareManually, setIsShareManually] = useState(companySurveyItem.shareManually);
    const addedBySelfRef = useRef(null);
    const [addedBySelf, setAddedBySelf] = useState(companySurveyItem.addedBySelf);
    const addedByBuyerRef = useRef(null);
    const [addedByBuyer, setAddedByBuyer] = useState(companySurveyItem.addedByBuyer);

    function submitComplete() {
        setIsSubmit(false);
    }

    function submitDelete(event, companySurveyItem) {
        setError("");
        setIsSubmit(true);
        handleDeleteClick(event, companySurveyItem, submitComplete);
    }

    const onResponseChange = (event) => {
        //console.log(event.target + "  " + event.target.name + " " + event.target.checked);
        const { name, id } = event.target;
        //event.preventDefault();
        //event.stopPropagation();
        if (name.startsWith("addedBySelf_")) {
            setAddedBySelf(event.target.checked);
        } else if (name.startsWith("addedByBuyer_")) {
            setAddedByBuyer(event.target.checked);
        } else if (name.startsWith("shouldBeReviewed_")) {
            setIsShouldBeReviewed(event.target.checked);
        } else if (name.startsWith("shareManually_")) {
            setIsShareManually(event.target.checked);
        }
    }

    function handleEditClick(event) {
        //event.preventDefault();
        //event.stopPropagation();
        setIsSubmit(false);
        setIsEditMode(true);
    }

    function submitUpdate(event, companySurveyItem) {
        //event.preventDefault();
        //event.stopPropagation();
        setError("");
        setIsSubmit(true);
        let updatedValues = {
            appSurveyKey: companySurveyItem.appSurveyKey,
            addedBySelf: addedBySelfRef.current.checked,
            addedByBuyer: addedByBuyerRef.current.checked,
            shouldBeReviewed: shouldBeReviewedRef.current.checked,
            shareManually: shareManuallyRef.current.checked,
        };
        handleSubmit(2, updatedValues, submitUpdateComplete);
    }
    function submitUpdateComplete() {
        setIsSubmit(false);
        setIsEditMode(false);
    }
    function submitCancel(event, companySurveyItem) {
        //event.preventDefault();
        //event.stopPropagation();
        setError("");
        setAddedBySelf(companySurveyItem.addedBySelf);
        setAddedByBuyer(companySurveyItem.addedByBuyer);
        setIsShouldBeReviewed(companySurveyItem.shouldBeReviewed);
        setIsShareManually(companySurveyItem.shareManually);
        setIsEditMode(false);
        setIsSubmit(false);
    }
    return (
        <tr key={index}>
            <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{companySurveyItem.surveyDisplayName}</td>
            {isEditMode ? (
                <>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={addedBySelfRef}
                            name={"addedBySelf_" + companySurveyItem.appSurveyKey}
                            id={"addedBySelf_" + companySurveyItem.appSurveyKey}
                            defaultChecked={true}
                            checked={addedBySelf}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={addedByBuyerRef}
                            name={"addedByBuyer_" + companySurveyItem.appSurveyKey}
                            id={"addedByBuyer_" + companySurveyItem.appSurveyKey}
                            defaultChecked={false}
                            checked={addedByBuyer}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={shouldBeReviewedRef}
                            name={"shouldBeReviewed_" + companySurveyItem.appSurveyKey}
                            id={"shouldBeReviewed_" + companySurveyItem.appSurveyKey}
                            defaultChecked={false}
                            checked={isShouldBeReviewed}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={shareManuallyRef}
                            name={"shareManually_" + companySurveyItem.appSurveyKey}
                            id={"shareManually_" + companySurveyItem.appSurveyKey}
                            defaultChecked={false}
                            checked={isShareManually}
                            onChange={onResponseChange}
                        />
                    </td>
                </>
            ) : (
                <>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + companySurveyItem.addedBySelf}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + companySurveyItem.addedByBuyer}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + companySurveyItem.shouldBeReviewed}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + companySurveyItem.shareManually}</td>
                </>
            )}

            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{companySurveyItem.status}</td>
            <td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                {isEditMode ? (
                    <>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 pe-none" : "btn btn-primary btn-block me-2"}
                            onClick={(event) => submitUpdate(event, companySurveyItem)}>{t("page.submit")}</button>
                        <button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block me-4"}
                            onClick={(event) => (submitCancel(event, companySurveyItem))}>{t("page.cancel")}</button>
                    </>
                ) : (
                    <>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 pe-none" : "btn btn-primary btn-block me-2"}
                            onClick={(event) => handleEditClick(event)}>{t("page.edit")}</button>
                        <button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block me-4"} onClick={(event) => submitDelete(event, companySurveyItem)}>
                            {companySurveyItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
                    </>
                )}
            </td>


        </tr>
    )
}
export default CompanySurveyReadOnlyRow;